"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unregister = exports.close = exports.setSoftDisabled = exports.softDisabled = exports.askForPermission = exports.trySubscribe = exports.supported = exports.status = exports.Status = void 0;
const constants_1 = require("./constants");
const service_1 = __importDefault(require("./services/notifications/service"));
const base64 = __importStar(require("./utils/base64Functions"));
const store_1 = __importDefault(require("./store"));
const gotoChat_1 = require("./actions/chats/gotoChat");
// https://web-push-book.gauntface.com/common-notification-patterns/
// - Once subscribed send the user an initial notification a la slack "Nice, notifications are enabled!"
// https://www.youtube.com/watch?v=_dXBibRO0SM&t=103s
var Status;
(function (Status) {
    Status[Status["Unsupported"] = 0] = "Unsupported";
    Status[Status["Prompt"] = 1] = "Prompt";
    Status[Status["Denied"] = 2] = "Denied";
    Status[Status["Granted"] = 3] = "Granted";
})(Status = exports.Status || (exports.Status = {}));
function status() {
    return __awaiter(this, void 0, void 0, function* () {
        // Does the browser and environment have all the support needed for web push
        if (!supported()) {
            return Status.Unsupported;
        }
        // If the user has explicitly soft-disabled notifications, then don't show bar
        if (yield softDisabled()) {
            return Status.Denied;
        }
        // If the user has already either hard enabled or hard disabled notifications then don't show the bar
        const permission = yield hardPermission();
        switch (permission) {
            case "denied":
                return Status.Denied;
            case "granted":
                return Status.Granted;
            default:
                return Status.Prompt;
        }
    });
}
exports.status = status;
function supported() {
    return "serviceWorker" in navigator
        && "PushManager" in window
        && "Notification" in window;
}
exports.supported = supported;
function trySubscribe(userId) {
    return __awaiter(this, void 0, void 0, function* () {
        // Register a service worker if it hasn't already been done
        let registration = yield registerServiceWorker();
        if (registration == null) {
            return false;
        }
        // Ensure the service worker is updated to the latest version
        registration.update();
        // When a notifcation is clicked the service worker sends us a message
        // with the chat to select
        navigator.serviceWorker.addEventListener("message", event => {
            if (event.data.type === "NOTIFICATION_CLICKED") {
                store_1.default.dispatch(gotoChat_1.gotoChatById(event.data.chatId));
            }
        });
        // Only proceed if the user hasn't explicitly soft-disabled notifications
        if (yield softDisabled()) {
            return false;
        }
        // Only proceed if the user has granted hard permission to send notifications
        const permission = yield hardPermission();
        if (permission !== "granted") {
            return false;
        }
        // Check if the user has subscribed already
        let pushSubscription = yield registration.pushManager.getSubscription();
        if (pushSubscription) {
            // Check if the subscription has already been pushed to the notifications canister
            if (yield service_1.default.subscriptionExists(userId, extract_p256dh_key(pushSubscription))) {
                return true;
            }
        }
        else {
            // Subscribe the user to webpush notifications
            pushSubscription = yield subscribeUserToPush(registration);
            if (pushSubscription == null) {
                return false;
            }
        }
        // Add the subscription to the user record on the notifications canister
        try {
            yield service_1.default.pushSubscription(userId, pushSubscription);
            return true;
        }
        catch (e) {
            console.log(e);
            return false;
        }
    });
}
exports.trySubscribe = trySubscribe;
function askForPermission() {
    return __awaiter(this, void 0, void 0, function* () {
        const result = yield new Promise(function (resolve, reject) {
            const permissionResult = Notification.requestPermission(function (res) {
                resolve(res);
            });
            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        });
        return result;
    });
}
exports.askForPermission = askForPermission;
// TODO: need to store in local storage
let _softDisabled = false;
function softDisabled() {
    return __awaiter(this, void 0, void 0, function* () {
        return _softDisabled;
    });
}
exports.softDisabled = softDisabled;
function setSoftDisabled(disabled) {
    return __awaiter(this, void 0, void 0, function* () {
        _softDisabled = disabled;
    });
}
exports.setSoftDisabled = setSoftDisabled;
function close(chatId) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let registration = yield registerServiceWorker();
        if (registration != null) {
            let notifications = yield registration.getNotifications();
            for (let notification of notifications) {
                if (((_a = notification.data) === null || _a === void 0 ? void 0 : _a.chatId) === chatId) {
                    notification.close();
                }
            }
        }
    });
}
exports.close = close;
function unregister() {
    return __awaiter(this, void 0, void 0, function* () {
        let registration = yield registerServiceWorker();
        if (registration == null) {
            return false;
        }
        return registration.unregister();
    });
}
exports.unregister = unregister;
function registerServiceWorker() {
    return __awaiter(this, void 0, void 0, function* () {
        // Does the browser have all the support needed for web push
        if (!supported()) {
            return null;
        }
        try {
            const sw_path = process.env.WEBPUSH_SERVICE_WORKER_PATH;
            return yield navigator.serviceWorker.register(sw_path);
        }
        catch (e) {
            console.log(e);
            return null;
        }
    });
}
function hardPermission() {
    return __awaiter(this, void 0, void 0, function* () {
        if (navigator.permissions) {
            let result = yield navigator.permissions.query({ name: "notifications" });
            switch (result.state) {
                case "prompt":
                    return "default";
                case "denied":
                    return "denied";
                case "granted":
                    return "granted";
            }
        }
        return Notification.permission;
    });
}
function subscribeUserToPush(registration) {
    return __awaiter(this, void 0, void 0, function* () {
        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: base64.toUint8Array(constants_1.PUBLIC_VAPID_KEY),
        };
        try {
            let pushSubscription = yield registration.pushManager.subscribe(subscribeOptions);
            return pushSubscription;
        }
        catch (e) {
            console.log(e);
            return null;
        }
    });
}
function extract_p256dh_key(subscription) {
    const json = subscription.toJSON();
    const key = json.keys["p256dh"];
    return key;
}
